import { useEffect } from "react";
import MenuMain from "../../components/MainMenu/MenuMain/MenuMain";
import s from "./MainPage.module.scss";
import load3kit from "../../utils/threekit/loadThreekit";
import { Button } from "antd";
import ArrowRightIcon from "../../assets/svgCompopnent/ArrowIcon";
import InStoreSkuOrder from "../../components/InStoreSkuOrder/InStoreSkuOrder";
import { getIsInStore, getUserType } from "../../redux/selectors/ui.selector";
import { useAppSelector } from "../../utils/hooks";
export default function MainPage() {
  const userType = useAppSelector(getUserType);
  const inStore = useAppSelector(getIsInStore);
  // The SKU / CSV order tool shows only for wholesale users outside in-store mode.
  const showSkuOrder = userType === "wholesale" && inStore === false;

  useEffect(() => {
    window.sessionStorage.setItem("store", "{}");
    window.sessionStorage.setItem("itemType", "");

    if (window.player) {
      window.player.unload();
    }

    load3kit();
  }, []);

  return (
    <div className={s.main}>
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.logo}>
            <img src="/images/assets/MainLogo.png" alt="" />
          </div>
          <div className={s.title}>Furniture made for the way you live</div>

          <div className={s.subtitle}>Customize every detail in just a few clicks</div>
        </div>
        {showSkuOrder && <InStoreSkuOrder />}
        <div className={s.catalog__block}>
          <MenuMain />

          {/* <MenuSub /> */}
        </div>
        <Button
          iconPosition="end"
          icon={<ArrowRightIcon />}
          target="_blank"
          href="https://www.jonathanlouis.com/"
          className={s.cta}
        >
          Go to jonathanlouis.com
        </Button>
      </div>
    </div>
  );
}
